var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOthersFunc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 45,
    viewBox: "0 0 37 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44622 34C0.175176 35.7795 -0.0618775 38.5929 0.0122113 40.9289C0.0877633 43.3111 2.16193 45 4.5453 45H32.205C34.4231 45 36.3981 43.5366 36.7052 41.3398C37.0802 38.6566 37.1438 35.1977 35.4463 33.5C32.9625 31.016 26.7078 28.8748 24.6296 28.2117C24.1746 28.0666 23.7039 28 23.2263 28H14.5619C14.1531 28 13.7504 28.0485 13.3562 28.1566C11.1742 28.7549 3.57953 31.0134 1.44622 34Z",
    fill: "#FC007F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.4463,
    y: 11,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#E2B19F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.44629,
    y: 11,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#E2B19F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9463 22H13.9463V28L18.9463 32.5L23.9463 28V22Z",
    fill: "#E2B19F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4463 10.8372C10.4463 4 19.2205 4 19.2205 4C19.2205 4 27.4463 5.46512 27.4463 10.8372C27.4463 16.2093 26.9463 18.5 26.9463 18.5C26.9463 18.5 25.8011 25 18.6721 25C11.5431 25 10.9463 18.5 10.9463 18.5C10.9463 18.5 10.4463 17.6744 10.4463 10.8372Z",
    fill: "#EAC5AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44629 11H10.9463C10.9463 11 11.9463 7.5 13.9463 7.5C15.9463 7.5 16.9463 8.5 18.9463 8.5C20.9463 8.5 21.9463 7.5 23.9463 7.5C25.9463 7.5 26.9463 11 26.9463 11H28.4463C28.4463 11 28.4463 0 18.9463 0C9.44629 0 9.44629 11 9.44629 11Z",
    fill: "#37474F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4463 29L13.9463 28L18.9463 31.5L23.9463 28L26.9463 29C26.9463 29 24.4463 36 22.9463 36C21.4463 36 18.9463 32.5 18.9463 32.5C18.9463 32.5 16.4463 36 14.9463 36C13.4463 36 10.4463 29 10.4463 29Z",
    fill: "#89A9FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9463,
    cy: 37.5,
    r: 0.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9463,
    cy: 40.5,
    r: 0.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9463,
    cy: 43.5,
    r: 0.5,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthersFunc);
export default __webpack_public_path__ + "static/media/others-func.29bcab1cc2f980ce0ce8467a34e1742a.svg";
export { ForwardRef as ReactComponent };